import React, { Fragment } from 'react'
import {
    IconButton,
    Table,
    TableHead,
    TextField,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(0),
        minWidth: 100,
    },
    root:{
        "&$hover":{outline:"none",borderColor:"#ffffff"},
        color:"#ffffff",
        outline:"none",
        border:"none",
        borderRadius: 5,
        "& > div":{
            color:"#ffffff",
            outline:"none",
            fontSize:"0.9em",
            "&$hover":{outline:"none",borderColor:"#ffffff"},
        },
        "&  svg":{
            fill:"#ffffff",
            color:"#ffffff",
            "&  path":{
                fill:"#ffffff"
            }

        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "0px solid #484850",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "0px solid #484850",
            overflow:"hidden"
        },
    }
}));

const GetTypeStatusReceipt = ({status})=>{

    const classes = useStyles();

    const colorsArrayStyle = [
        {backgroundColor:"#ff6b81",color:"#ffffff !important",textTransform: "none"},
        {backgroundColor:"#26de81",color:"#ffffff",textTransform: "none"},
        {backgroundColor:"#70a1ff",color:"#ffffff",textTransform: "none"},
    ];

    return (
        <FormControl className={classes.formControl}>

            <TextField
                defaultValue={status}
                id="grouped-select"
                variant="outlined"
                size="small"
                select
                style={colorsArrayStyle[status]}
                value={status}
                onChange={(event)=>{
                    console.log("Заменяем на ",event.target.value);
                }}

                classes={{
                    root: classes.root,
                }
                }

                //color="#ffffff"
            >
                <MenuItem value="">
                    <em>Не известно</em>
                </MenuItem>
                {/*<ListSubheader>Category 1</ListSubheader>*/}
                <MenuItem value={0}>Ожидает</MenuItem>
                <MenuItem value={1}>Доставлен</MenuItem>
                {/*<ListSubheader>Category 2</ListSubheader>*/}
                {/*<MenuItem value={3}>Option 3</MenuItem>*/}
                {/*<MenuItem value={4}>Option 4</MenuItem>*/}
            </TextField>
        </FormControl>
    );
};

export default GetTypeStatusReceipt;